import PropTypes from "prop-types";
import cx from "classnames";
import Button from "@src/template/components/Button";
import styles from "./MenaBanner.css";
import stylesDeferred from "./MenaBanner.deferred.css";

const MenaBanner = ({ onShopMena, onStayHere }) => (
  <div
    className={cx(styles.container, stylesDeferred.container)}
    role="region"
    aria-label="Option to switch to the local, Middle East store for your location."
    data-testid="mena-banner"
  >
    <p className={styles.message}>
      Shopping from the Middle East? We&#39;ve launched a local store with
      faster delivery and local payment options.
    </p>
    <div className={stylesDeferred.buttons}>
      <Button theme="primary" onClick={onShopMena}>
        SHOP MENA
      </Button>
      <Button
        theme="secondary"
        classes={stylesDeferred.stayHereButton}
        onClick={onStayHere}
      >
        STAY HERE
      </Button>
    </div>
  </div>
);

MenaBanner.propTypes = {
  onShopMena: PropTypes.func.isRequired,
  onStayHere: PropTypes.func.isRequired
};

export default MenaBanner;
